module.exports = __webpack_public_path__ + "assets/img/ian-min.ca08f106.jpeg";